import React, { useMemo } from 'react'
import {
  ROLES_SIXT,
  ROLE_B2C,
  ROLE_PARTNER_READ_ONLY,
  ROLE_READ_ONLY,
  useAuth,
} from 'auth'

import CarDetails from 'components/organisms/CarDetails'
import CarsToBuyCarDetailsRightBottom from 'components/organisms/CarsToBuy/CarsToBuyCarDetailsRightBottom'

import CarDetailsPageTitle from '../CarDetails/CarDetailsPageTitle'
import { getRepriceValues } from '../../../lib/repriceFee'

export default function CarsToBuyDetails({
  partnerId,
  vin,
  session,
  isFetching,
  updateChoice,
  cars,
  isFetchingCars,
  isUpdatingCars,
  setShowDetails,
  allCars,
}) {
  const { getPartnerId } = useAuth()
  const { hasOneOfRoles } = useAuth()
  const admin = useMemo(() => hasOneOfRoles(ROLES_SIXT), [hasOneOfRoles])
  const userRoleHasReadOnly = useMemo(
    () => hasOneOfRoles([ROLE_READ_ONLY, ROLE_B2C, ROLE_PARTNER_READ_ONLY]),
    [hasOneOfRoles]
  )

  const myPartnerId = useMemo(
    () => (admin ? partnerId : getPartnerId()),
    [admin, getPartnerId, partnerId]
  )

  const readOnly = useMemo(
    () => isFetchingCars || isFetching || isUpdatingCars,
    [isFetchingCars, isFetching, isUpdatingCars]
  )

  const car = useMemo(() => {
    return (
      vin && cars.find((car) => car.vin.toLowerCase() === vin.toLowerCase())
    )
  }, [vin, cars])

  const repriceValues = car?.reprice
    ? getRepriceValues(car.reprice, car.feePercentage)
    : {}

  const priceNetToShow = car?.reprice ? repriceValues.repriceNet : car?.price
  const feeToShow = car?.reprice ? repriceValues.repriceFee : car?.fee

  return (
    <div className="content-container" data-testid="cars-to-buy-details">
      <>
        <CarDetailsPageTitle
          setShowDetails={setShowDetails}
          cars={cars}
          vin={vin}
        />
        {car && (
          <CarDetails
            car={car}
            price={priceNetToShow}
            fee={feeToShow}
            maxPrice={car.maxPrice}
            rightBottom={
              <CarsToBuyCarDetailsRightBottom
                variant="column"
                session={session}
                partnerId={myPartnerId}
                cars={allCars}
                car={car}
                updateChoice={updateChoice}
                readOnly={admin || readOnly || userRoleHasReadOnly}
              />
            }
          />
        )}
      </>
    </div>
  )
}
